import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = (props) => {
  const { redirectPath, component, render: renderProp, user, ...routeProps } = props;
  const Component = component;

  const auth = useSelector((state) => state.auth);
  const isAccessible = Boolean(auth.user) && auth.isLoggedIn;

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (isAccessible) {
          if (renderProp) return renderProp(props);
          return <Component {...props} />;
        }

        const state = { from: props.location };
        const pathname = redirectPath || "/login";

        return <Redirect to={{ state, pathname }} />;
      }}
    />
  );
};

export default ProtectedRoute;
